import React, { Component } from 'react';
import { ImagePicker } from 'react-file-picker'

import './css/Header.css';
import StringUtils from "../../utils/StringUtils";

class Header extends Component {

    state = {};

    componentWillMount() {
        const header = this.props.header;
        const description = StringUtils.removeImage(this.props.description);
        const descriptionImage = StringUtils.getLastImage(this.props.description);

        this.setState({
            header: header,
            description: description,
            descriptionImage: descriptionImage
        })
    }

    setHeader = (event) => {
        const header = event.target.value;
        this.setState({ header: header });
        this.props.setHeader(this.props.id, header);
    };

    setDescription = (event) => {
        const description = event.target.value;
        this.setState({ description: description }, this.saveDescription);
    };

    removeDescriptionImage = () => {
        this.setState({ descriptionImage: null }, this.saveDescription);
    };

    saveDescription = () => {
        let description = this.state.description;
        const image = this.state.descriptionImage;
        if (image != null) {
            description += ` {img=${image}}`;
        }

        this.props.setDescription(this.props.id, description);
    }

    render() {

        const descriptionImage = (<img alt="external" className="external-image" src={this.state.descriptionImage} />);

        return (
            <div className="header-edit">
                {this.props.isFirst ? '' : <button className="btn-square" onClick={this.props.moveUp}><i className="fas fa-arrow-up"></i></button>}
                {this.props.isLast ? '' : <button className="btn-square" onClick={this.props.moveDown}><i className="fas fa-arrow-down"></i></button>}
                <div className="header-title">
                    <input type="text" placeholder="Nagłówek" value={this.state.header} className="header-title-value" onChange={this.setHeader} />
                    <button className="btn-square" onClick={this.deleteQuestion}><i className="far fa-trash-alt" /></button>
                </div>
                <div className="header-description">
                    <textarea placeholder="Opis" class="header-description-value" value={this.state.description} onChange={this.setDescription} />
                    {this.state.descriptionImage != null ? descriptionImage : ''}
                    <ImagePicker
                        extensions={['jpg', 'jpeg', 'png']}
                        dims={{ minWidth: 100, minHeight: 100 }}
                        onChange={base64EncodedString => this.setState({ descriptionImage: base64EncodedString })}
                        onError={errMsg => console.log(errMsg)}
                        style={{ display: "inline-block" }}
                    >
                        <button className="btn-square"><i className="far fa-image" /></button>
                    </ImagePicker>
                    {this.state.descriptionImage != null ? <button className="btn-square" onClick={this.removeDescriptionImage}><i className="fas fa-ban" /></button> : ''}

                </div>
            </div>
        )
    }
}

export default Header;